import { useEffect } from "react";

// Počet současně otevřených zámků. Bez čítače se překryvající popup
// (např. nahlášení uvnitř chatu) při zavření odemkl stránku, i když
// chat zůstal otevřený – každý zám jen nastavil body overflow na "".
let lockCount = 0;

const applyLock = () => {
    document.body.style.overflow = "hidden";
    document.body.style.paddingRight = "0px";
};

const releaseLock = () => {
    lockCount = Math.max(0, lockCount - 1);

    if (lockCount === 0) {
        document.body.style.overflow = "";
        document.body.style.paddingRight = "";
    }
};

export const useScrollLock = (isLocked) => {
    useEffect(() => {
        if (!isLocked) return undefined;

        lockCount += 1;
        applyLock();

        // Odemkneme jen když poslední zamek zmizí
        return releaseLock;
    }, [isLocked]);
};